import {
  CHANGE_LANGUAGE,
  CHANGE_LANGUAGE_ERROR,
  CHANGE_LANGUAGE_SUCCESS,
  GET_LANGUAGE,
  GET_LANGUAGE_ERROR,
  GET_LANGUAGE_SUCCESS,
} from "./actionTypes";
import { AError } from "../../requests/types";
import {
  ErrorChangeLanguage as ErrorChangeLanguageType,
  ErrorGetLanguage as ErrorGetLanguageType,
  SuccessChangeLanguage as SuccessChangeLanguageType,
  SuccessGetLanguage as SuccessGetLanguageType,
} from "./types";
import { LangCode } from "../../requests/localization/types";

export const ChangeLanguage = () => ({
  type: CHANGE_LANGUAGE,
});

export const ErrorChangeLanguage = (
  error: AError
): ErrorChangeLanguageType => ({
  type: CHANGE_LANGUAGE_ERROR,
  error,
});

export const SuccessChangeLanguage = (
  langCode: LangCode
): SuccessChangeLanguageType => ({
  type: GET_LANGUAGE_SUCCESS,
  item: langCode,
});

export const GetLanguage = () => ({
  type: GET_LANGUAGE,
});

export const ErrorGetLanguage = (error: AError): ErrorGetLanguageType => ({
  type: GET_LANGUAGE_ERROR,
  error,
});

export const SuccessGetLanguage = (
  langCode: LangCode
): SuccessGetLanguageType => ({
  type: GET_LANGUAGE_SUCCESS,
  item: langCode,
});
